/**
 * flagState - the API's 503 FLAG_STATE_UNKNOWN (corporate Business PAD
 * contract, Amendments A4.3 and A5): a flag that gates a money path (ACH
 * generation, release or settlement) could not be read, so the operation was
 * aborted and nothing was written. It never means "off".
 *
 * Two shapes are live:
 *   ACH routes, wire queue  { status:false, code, message }
 *   AD console mark-paid    { status:503, code, message, data:{ investment_id, reason, flag } }
 * The code is read from any of those places, and the words are the admin's
 * own, never the server's message.
 */
export const FLAG_STATE_UNKNOWN = "FLAG_STATE_UNKNOWN";

export const FLAG_STATE_UNKNOWN_TEXT = "A required setting could not be read. Nothing was changed. Try again.";

/** Is this refusal body a FLAG_STATE_UNKNOWN (top level, or under data as its code or its reason)? */
export function isFlagStateUnknown(body) {
  if (!body || typeof body !== "object") return false;
  if (body.code === FLAG_STATE_UNKNOWN) return true;
  const data = body.data && typeof body.data === "object" ? body.data : null;
  return !!data && (data.code === FLAG_STATE_UNKNOWN || data.reason === FLAG_STATE_UNKNOWN);
}
